import React from 'react'
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet'
import { strReplace } from 'utils/redux/helpers'

export const Meta = ({page, name, abbreviature}) => {
	const meta = window.__META__[page]

	if (!meta) return null

	return <Helmet>
		<title>{page === 'currency' || page === 'cryptocurrency' ? strReplace(meta.title, name, abbreviature) : meta.title}</title>
		<meta name="description" content={page === 'currency' ? strReplace(meta.description, name, abbreviature) : meta.description} />
	</Helmet>
}

Meta.propTypes = {
	page: PropTypes.string,
	name: PropTypes.string,
	abbreviature: PropTypes.string,
}

export default Meta
